import { render, staticRenderFns } from "./CommissionStatusBadge.vue?vue&type=template&id=aa9003c6&"
import script from "./CommissionStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./CommissionStatusBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports